/**
 * <in-grid-audience-promo-card> — matches its height to a sibling product
 * card's .card__media box (desktop only; mobile spans full width alone).
 */
class InGridAudiencePromoCard extends HTMLElement {
  constructor() {
    super();
    this.mql = window.matchMedia('(min-width: 990px)');
    this.onResize = this.onResize.bind(this);
  }

  connectedCallback() {
    this.matchHeight();
    window.addEventListener('resize', this.onResize);
    this.mql.addEventListener('change', this.onResize);
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.onResize);
    this.mql.removeEventListener('change', this.onResize);
  }

  onResize() {
    clearTimeout(this._resizeTimeout);
    this._resizeTimeout = setTimeout(() => this.matchHeight(), 100);
  }

  matchHeight() {
    if (!this.mql.matches) {
      this.style.height = '';
      return;
    }

    const li = this.closest('.grid__item');
    const grid = li && li.closest('.grid');
    if (!li || !grid) return;

    const sibling = Array.from(grid.children).find(
      (el) => el !== li && el.classList && el.classList.contains('grid__item')
    );
    const media = sibling && sibling.querySelector('.card__media');
    if (!media) {
      this.style.height = '';
      return;
    }

    this.style.height = `${media.getBoundingClientRect().height}px`;
  }
}

if (!customElements.get('in-grid-audience-promo-card')) {
  customElements.define('in-grid-audience-promo-card', InGridAudiencePromoCard);
}
